/**
 * API_CONTRACT.md §8's closed field-error-code set (`required`, `invalid_type`,
 * `invalid_format`, `too_short`, `too_long`, `out_of_range`, `not_allowed_value`,
 * `unknown_field`), rendered generically. A form's own `fieldErrorFor` closure (the
 * pattern `AppointmentRequestPage.tsx` established) should still override any of these
 * with field-specific copy where one reads better — this is the fallback shared across
 * the four new administration forms so each does not re-invent the same eight-way switch.
 */
export function genericFieldErrorMessage(
  t: (key: string, vars?: Record<string, string | number>) => string,
  code: string,
  params?: Record<string, unknown>,
): string {
  switch (code) {
    case 'required':
      return t('fieldError.required');
    case 'invalid_type':
      return t('fieldError.invalidType');
    case 'invalid_format':
      return t('fieldError.invalidFormat');
    case 'too_short':
      return t('fieldError.tooShort', { min: typeof params?.min === 'number' ? params.min : '' });
    case 'too_long':
      return t('fieldError.tooLong', { max: typeof params?.max === 'number' ? params.max : '' });
    case 'out_of_range':
      return t('fieldError.outOfRange');
    case 'not_allowed_value':
      return t('fieldError.notAllowedValue');
    case 'unknown_field':
      return t('fieldError.unknownField');
    default:
      return t('fieldError.generic');
  }
}
